// Typelizer digest ebd8a3c0b5dda3ee984ed6198e95628f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/vat_return */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/vat_return', {}, options),
    method: 'get',
  }),
}
